import script from "./deliOnceImg6.vue?vue&type=script&setup=true&lang=js"
export * from "./deliOnceImg6.vue?vue&type=script&setup=true&lang=js"

import "./deliOnceImg6.vue?vue&type=style&index=0&id=eb9dcf38&lang=less"

const __exports__ = script;

export default __exports__